import { lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';

const LazyFaceIds = lazy(() => import('./FaceIds'));

const FaceIds = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => {
  const { type } = useParams();

  return (
    <Suspense fallback={null}>
      <LazyFaceIds key={type} {...props} />
    </Suspense>
  );
};

export default FaceIds;
